import axios from "axios";
import { PropManagementDTO } from "../dto/PropManagementDTO";
import { PropMetadata } from "../dto/PropMetadata";

var CREATOR_URL = process.env.REACT_APP_PLAYIT_CREATORAPI;

export type ManagementPropType = 0 | 1;

export class PropManagementService {
  static async UpdateProp(
    token: string,
    orgId: string,
    propType: ManagementPropType,
    propId: string,
    dto: PropManagementDTO
  ) {
    const path = `/mgmt/organizations/${orgId}/${propType}/${propId}`;
    const url = CREATOR_URL + path;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json-patch+json",
      },
    };

    const { status } = await axios.put(url, dto, config);
    return status === 204; // no content = success
  }

  static async UpdatePropMetadata(
    token: string,
    orgId: string,
    propType: ManagementPropType,
    propId: string,
    metadata: PropMetadata
  ) {
    const path = `/mgmt/organizations/${orgId}/${propType}/${propId}/content`;
    const url = CREATOR_URL + path;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const formData = new FormData();
    formData.append(
      "File",
      new Blob([JSON.stringify(metadata)], { type: "application/json" }),
      "file.json"
    );

    const multipartConfig = {
      ...config,
      headers: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    };

    const { status } = await axios.post(url, formData, multipartConfig);
    return status === 201; // created = success
  }
}
